import {
  ChangeDetectorRef, Component, EventEmitter,
  Input, Output, ViewChild, ElementRef,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { prettifySize } from 'utils/prettify';
import { UploadOutput, UploadInput, UploadFile } from 'shared/ngx-uploader/classes/ngx-uploader.class';
import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { Config } from 'shared/config/env.config';
import { AuthService} from 'shared/auth/auth.service';
import { BrandService} from 'shared/brand/brand.service';


@Component({
  moduleId: module.id,
  selector: 'import-upload-modal',
  templateUrl: 'import-upload-modal.component.html',
  styleUrls: ['import-upload-modal.component.scss'],
})
export class ImportUploadModalComponent extends BaseModalComponent {
  // set xml by default until flatfile is avaliable
  type: string = 'PIES';
  typesList: Array<any> = [
    {
      title: 'These are Products',
      value: 'PIES',
    },
    {
      title: 'These are Fitments',
      value: 'ACES',
    },
    {
      title: 'These are custom fields',
      value: 'CUSTOM FIELDS',
    },
  ];
  mimetypes: string = '.xml,.xlsx';
  selectedFile: any;

  // files uploading
  isUploadStarted: boolean;
  uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
  isUploadFinished: boolean = false;
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef | void;
  @Output() fileUploaded: EventEmitter<any> = new EventEmitter();

  constructor(
    protected ref: ChangeDetectorRef,
    private authService: AuthService,
    private brandService: BrandService,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get brandId(): any {
    return this.brandService.getBrand();
  }

  get isFileSelected(): boolean {
    return !!this.selectedFile;
  }

  get isXml(): boolean {
    if (!this.isFileSelected) { return false; }
    return this.selectedFile.name.indexOf('.xml') > 0;
  }

  get isXlsx(): boolean {
    if (!this.isFileSelected) { return false; }
    return this.selectedFile.name.indexOf('.xlsx') > 0;
  }

  get filename(): string {
    if (!this.isFileSelected) { return ''; }
    return this.selectedFile.name;
  }

  get filesize(): string {
    if (!this.isFileSelected) { return ''; }
    return prettifySize(this.selectedFile.size);
  }

  get isUploadInProgress(): boolean {
    return this.isUploadStarted && !this.isUploadFinished;
  }

  get uploadProgressPercent(): number {
    if (!this.selectedFile) { return 0; }
    return Math.round(this.selectedFile.progress.data.percentage);
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

   public show() {
     this.clearData();
     super.show();
   }

   public hide() {
     if (this.isUploadFinished) {
       this.fileUploaded.emit();
     }
     super.hide();
   }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onChooseBtnClick() {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onUploadOutput(output: UploadOutput) {
    if (output.type === 'addedToQueue' && output.file) {
      this.selectedFile = output.file;
    }
    this.isUploadFinished = (output.type === 'done');
    this.ref.markForCheck();
  }

  onImportBtnClick() {
    this.startUploadProcess();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private startUploadProcess() {
    this.isUploadStarted = true;

    const event: UploadInput = {
      type: 'uploadFile',
      url: `${Config.API}/imports-upload/${this.brandId}`,
      method: 'POST',
      file: this.selectedFile,
      data: {type: this.type},
      headers: {
        'Authorization': `Bearer ${this.authService.token()}`,
      },
      withCredentials: false,
    };
    this.ref.markForCheck();
    this.uploadInput.emit(event);
  }

  private clearData() {
    this.selectedFile = null;
    this.isUploadStarted = false;
    this.isUploadFinished = false;
    if (this.fileInput && _.get(this.fileInput, 'nativeElement.value')) {
      this.fileInput.nativeElement.value = '';
    }
    this.ref.markForCheck();
  }
}
